import { render, staticRenderFns } from "./newChangeEquip.vue?vue&type=template&id=1330912c&scoped=true"
import script from "./newChangeEquip.vue?vue&type=script&lang=js"
export * from "./newChangeEquip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1330912c",
  null
  
)

export default component.exports